import React from 'react'
import SimpleBar from 'simplebar-react'
import Preview from './components/Preview/Preview'
import { useTranslation } from 'react-i18next'
import LeadFormEditorView from './LeadFormEditorView'
import './Form.scss'

const Form = ({ structure, colorTheme, validateErrors, methods: { updateStructure } }) => {
    const { t } = useTranslation()

    return (
        <div className="lead-form__form">
            <LeadFormEditorView
                structure={structure}
                validateErrors={validateErrors}
                onUpdateStructure={updateStructure}
            />
            <div className="lead-form__form__preview-wrapper">
                <SimpleBar autoHide={false} style={{ maxHeight: '100%' }}>
                    <div className="lead-form__form__preview">
                        <p className="lead-form__form__preview-title">{t('Approximate preview')}</p>
                        <Preview
                            colorTheme={colorTheme}
                            fields={structure.form.fields}
                            logoImage={structure.form.logoImage}
                            headerText={structure.form.headerText}
                            descriptionText={structure.form.descriptionText}
                            buttonText={structure.form.buttonText}
                            linkPrivacyPolicyLink={structure.form.linkPrivacyPolicyLink}
                        />
                    </div>
                </SimpleBar>
            </div>
        </div>
    )
}

export default Form
